import type { ExtractionAiFieldCells } from '~/features/dynamic-data-extraction/types/ExtractionAiFieldCell';

export const normalizeAiFieldCellValue = (value?: string): string | undefined =>
  value;

export const normalizeAiFieldCells = (
  aiFieldCells: ExtractionAiFieldCells,
): ExtractionAiFieldCells =>
  Object.fromEntries(
    Object.entries(aiFieldCells).map(([cellKey, cell]) => [cellKey, cell]),
  );
